import http from '@/libs/http'
export default class BodegasServices {
  getBodegas () {
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/bodegas`)
  }
}
